import { useState, useEffect, useRef } from "react";
import Navbar from "./components/Navbar/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainPage from "./pages/MainPage/MainPage";
import Gallery from "./pages/Gallery/Gallery";
import Booking from "./pages/Booking/Booking";
import Popup from "./components/Popup/Popup";
import BlackFriday from "./assets/img/popup-black-friday.png";
import Christmas from "./assets/img/popup-christmas.jpg";

// function which limits resize event occurrence
function debounce(fn, ms) {
  let timer;
  return _ => {
    clearTimeout(timer);
    timer = setTimeout(_ => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}
const App = () => {
  // handling resize to put good components on mobile or desktop devices

  const [width, setWidth] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState(null);
  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setWidth(window.innerWidth);
    }, 100);
    window.addEventListener("resize", debouncedHandleResize);
    if (width > 1000) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
    return () => window.removeEventListener("resize", debouncedHandleResize);
  }, [width]);

  // references - scroll to section after navbar clicked
  const refs = {
    hero: useRef(),
    news: useRef(),
    visit: useRef(),
    reviews: useRef(),
    contact: useRef(),
  };

  return (
    <Router>
      <Navbar isMobile={isMobile} refs={refs} />

      <Popup
        name="BlackFriday"
        img={BlackFriday}
        dateStart={new Date(2025, 11 - 1, 27)}
        dateEnd={new Date(2025, 12 - 1, 5, 23, 59, 59)}
      />
      <Popup
        name="Christmas"
        img={Christmas}
        dateStart={new Date(2025, 12 - 1, 6)}
        dateEnd={new Date(2025, 12 - 1, 19, 23, 59, 59)}
      />

      <Routes>
        <Route path="/" element={<MainPage refs={refs} />} />
        <Route path="/galeria" element={<Gallery />} />
        <Route path="/rezerwacje" element={<Booking />} />
      </Routes>
      <footer>
        <a href="standardy_ochrony_malotenich.pdf">
          Standardy Ochrony Małoletnich
        </a>
        <p>Wszystkie prawa zastrzeżone.</p>
        <p>Copyright by Łeba Park © 2008-2025.</p>
      </footer>
    </Router>
  );
};

export default App;
